<template>
	<div>
		<div class="panel-header panel-header-custom bg-primary-gradient">
			<div class="page-inner py-5">
				<div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
					<div>
						<h2 class="text-white pb-2 fw-bold">{{ $t('Управление заявками') }}</h2>
					</div>
				</div>
			</div>
		</div>
		<div class="page-inner mt--5">
			<v-data-table
				:headers="orderHeaders"
				hide-default-header
				:items="orderList"
				:loading="isLoading"
				:items-per-page="pagination.itemsPerPage"
				:options.sync="pagination"
				:footer-props="{'items-per-page-options': [15, 30, 50, 100]}"
				:server-items-length="totalItems"
				class="elevation-1 place-list"
			>
				<template v-slot:header="">
					<thead class="v-data-table-header">
						<tr>
							<th
								v-for="(headerItem, headerIndex) in orderHeaders"
								:key="headerIndex"
								class="text-start"
								:width="headerItem.width"
							>
								<template v-if="headerItem.value === 'iin'">
									<v-text-field
										style="display: inline-block; width: 140px;"
										class="pt-5"
										v-model="filterIin"
										:label="headerItem.text"
										type="number"
										@wheel="$event.target.blur()"
										clearable
										dense
									></v-text-field>
								</template>
								<template v-else-if="headerItem.value === 'fio'">
									<v-text-field
										style="display: inline-block; width: 250px;"
										class="pt-5"
										v-model="filterFio"
										:label="headerItem.text"
										type="text"
										clearable
										dense
									></v-text-field>
								</template>
								<template v-else-if="headerItem.value === 'quota'">
									<v-select
										style="display: inline-block; width: 110px;"
										class="pt-5"
										v-model="filterQuota"
										:items="quotaFilterList"
										item-text="name"
										item-value="value"
										dense
										clearable
										:label="headerItem.text"
									></v-select>
								</template>
								<template v-else-if="headerItem.value === 'status'">
									<v-select
										style="display: inline-block; width: 150px;"
										class="pt-5"
										v-model="filterStatus"
										:items="statusFilterList"
										item-text="name"
										item-value="value"
										dense
										clearable
										:label="headerItem.text"
									></v-select>
								</template>
								<template v-else>
									{{ headerItem.text }}
								</template>
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:item.actions="{ item }">
					<v-btn
						v-if="!isRecalled(item)"
						small
						depressed
						color="error"
						@click.stop="openRecallDialog(item)"
					>
						{{ $t('Отозвать') }}
					</v-btn>
				</template>
			</v-data-table>

			<v-dialog
				v-model="recallDialog"
				width="600"
				transition="dialog-transition"
				:persistent="actionIsLoading"
			>
				<v-card>
					<v-card-title class="headline lighten-2">{{ $t('Отозвать заявку') }}</v-card-title>
					<v-card-text>
						<v-divider class="mb-5"></v-divider>
						<p class="mb-4">
							<strong>{{ currentOrder.fio }}</strong><br>
							{{ $t('ИИН') }}: {{ currentOrder.iin }}
						</p>
						<v-form class="form" ref="recallForm">
							<sign-ecp
								:key="'sign-ecp-recall-' + signEcpKey"
								@update-ecp-file-data="ecpFileData = $event"
								@update-ecp-password="ecpPassword = $event"
							/>
						</v-form>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-btn color="blue darken-1" text @click.stop="closeRecallDialog">{{ $t('Отмена') }}</v-btn>
						<v-spacer></v-spacer>
						<v-btn color="primary" text :loading="actionIsLoading" @click.stop="recallSubmit">
							{{ $t('Отозвать') }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
	</div>
</template>

<script>
	import {
		buildRecallOrderFormData,
		getCollegeOrderHeaders,
		getCollegeOrderPaginationMeta,
		isCollegeOrderRecalled,
		mapCollegeOrderList,
	} from '@/utils/college';

	export default {
		mounted() {
			this.orderHeaders = getCollegeOrderHeaders((key) => this.$t(key));
			this.quotaFilterList = [
				{ name: this.$t('Да'), value: this.$t('Да') },
				{ name: this.$t('Нет'), value: this.$t('Нет') },
			];
			this.getData();
		},
		data: () => ({
			isLoading: false,
			actionIsLoading: false,
			orderHeaders: [],
			orderList: [],
			allOrderList: [],
			totalItems: 0,
			pagination: {
				itemsPerPage: 15,
				page: 1,
			},
			filterIin: null,
			filterFio: null,
			filterQuota: null,
			filterStatus: null,
			quotaFilterList: [],
			statusFilterList: [],
			recallDialog: false,
			currentOrder: {},
			ecpFileData: null,
			ecpPassword: null,
			signEcpKey: 0,
			filterTimeoutId: null,
		}),
		methods: {
			isRecalled(item) {
				return isCollegeOrderRecalled(item && item.status);
			},
			applyClientFilters() {
				let list = [...this.allOrderList];
				if (this.filterIin) {
					const iin = String(this.filterIin).trim();
					list = list.filter((item) => String(item.iin || '').includes(iin));
				}
				if (this.filterFio) {
					const fio = String(this.filterFio).trim().toLowerCase();
					list = list.filter((item) => String(item.fio || '').toLowerCase().includes(fio));
				}
				if (this.filterQuota) {
					list = list.filter((item) => item.quota === this.filterQuota);
				}
				if (this.filterStatus) {
					list = list.filter((item) => item.status === this.filterStatus);
				}
				this.orderList = list;
			},
			buildStatusFilterList() {
				const statuses = [...new Set(this.allOrderList.map((item) => item.status).filter(Boolean))];
				this.statusFilterList = statuses.map((status) => ({ name: status, value: status }));
			},
			async getData() {
				this.isLoading = true;
				try {
					const response = await this.$http.get('/college-order', {
						params: {
							page: this.pagination.page,
							per_page: this.pagination.itemsPerPage,
						},
					});
					const payload = response.data && response.data.data;
					this.allOrderList = mapCollegeOrderList(payload);
					this.buildStatusFilterList();
					this.applyClientFilters();
					const meta = getCollegeOrderPaginationMeta(payload);
					this.totalItems = meta.total;
				} catch (error) {
					console.error('Ошибка загрузки заявок:', error);
					this.allOrderList = [];
					this.orderList = [];
					this.totalItems = 0;
				} finally {
					this.isLoading = false;
				}
			},
			openRecallDialog(item) {
				this.currentOrder = { ...item };
				this.ecpFileData = null;
				this.ecpPassword = null;
				this.signEcpKey += 1;
				this.recallDialog = true;
			},
			closeRecallDialog() {
				if (this.actionIsLoading) {
					return;
				}
				this.recallDialog = false;
				this.resetRecallDialogState();
			},
			resetRecallDialogState() {
				this.currentOrder = {};
				this.ecpFileData = null;
				this.ecpPassword = null;
			},
			waitForDialogClose() {
				return new Promise((resolve) => {
					setTimeout(resolve, 300);
				});
			},
			async recallSubmit() {
				if (!this.$refs.recallForm.validate()) {
					return;
				}
				this.actionIsLoading = true;
				try {
					const formData = buildRecallOrderFormData({
						id: this.currentOrder.id,
						ecp: this.ecpFileData,
						password: this.ecpPassword,
					});
					const response = await this.$http.post('/recall-order', formData);
					const message = (response.data && response.data.message)
						|| this.$t('Заявка успешно отозвана.');
					this.$store.dispatch('alertAdd', { text: message, type: 'success' });
					this.recallDialog = false;
					this.resetRecallDialogState();
					await this.waitForDialogClose();
					await this.getData();
				} catch (error) {
					console.error('Ошибка отзыва заявки:', error);
				} finally {
					this.actionIsLoading = false;
				}
			},
		},
		watch: {
			pagination: {
				handler() {
					this.getData();
				},
				deep: true,
			},
			filterIin() {
				clearTimeout(this.filterTimeoutId);
				this.filterTimeoutId = setTimeout(() => this.applyClientFilters(), 300);
			},
			filterFio() {
				clearTimeout(this.filterTimeoutId);
				this.filterTimeoutId = setTimeout(() => this.applyClientFilters(), 300);
			},
			filterQuota() {
				this.applyClientFilters();
			},
			filterStatus() {
				this.applyClientFilters();
			},
			'$store.state.language'() {
				this.orderHeaders = getCollegeOrderHeaders((key) => this.$t(key));
				this.quotaFilterList = [
					{ name: this.$t('Да'), value: this.$t('Да') },
					{ name: this.$t('Нет'), value: this.$t('Нет') },
				];
				this.getData();
			},
		},
	};
</script>
